<template>
  <v-system-bar color="primary" dark height="35">
    <v-icon left>{{ icon }}</v-icon>
    <span class="text-subtitle-1">{{ text }}</span>
  </v-system-bar>
</template>

<script>
export default {
  name: 'CardTitleBar',
  props: {
    icon: String,
    text: String,
  },
};
</script>
